<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link to="/" class="navbar-brand" active-class="none">{{title}}</router-link>
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <div class="navbar-nav mr-auto">
                <template v-if="!auth">
                    <router-link to="/about" class="nav-link" active-class="active">About</router-link>
                    <router-link to="/signin"  class="nav-link" active-class="active">Sign In</router-link>
                </template>
                <template v-if="isSU"> 
                    <router-link to="/controllers" class="nav-link" active-class="active">Controllers</router-link>
                    <router-link to="/sensors" class="nav-link" active-class="active">Sensors</router-link>
                    <router-link to="/actuators" class="nav-link" active-class="active">Actuators</router-link>
                </template>
                <template v-if="auth">                  
                    <a href="#" @click="onLogout" class="nav-link pointer" >Logout</a>
                </template>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            title: "Nola WebApp",
        };
    },
    computed: {
      auth () {
        return this.$store.getters.isAuthenticated
      },
      isSU() {
          return this.$store.getters.isSuperUser
      }

    },
    methods: {
      onLogout() {
        this.$store.dispatch('logout')
      }
    }
};
</script>